// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "svg[data-v-6911c50a]{fill:var(--projectPrimaryColor)}", "",{"version":3,"sources":["/app/src/components/icons/IconCoin/index.vue"],"names":[],"mappings":"AAgBA,qBACE,+BAAgC","file":"index.vue?vue&type=style&index=0&id=6911c50a&lang=scss&scoped=true&","sourcesContent":["@import \"./src/assets/scss/_variable.scss\";\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nsvg {\n  fill: var(--projectPrimaryColor);\n}\n"]}]);
// Exports
module.exports = exports;
